import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {AbstractFileSettleFormComponent} from '../abstract-file-settle-form.component';
import {
  EntityClassSelectorComponent,
  EntityClassSelectorUsage,
  ExtRetentionTriggerSelectorComponent,
  FileTypeSelectorComponent,
  VisibleClassifiersMode
} from '|shared';
import {SettlementType} from '|api/commons';
import {AlertComponent, IconComponent, SectionComponent} from '@icz/angular-essentials';
import {
  CheckboxComponent,
  DatePickerComponent,
  FormAutocompleteComponent,
  FormFieldComponent,
  IczFormContainerDirective,
  IczOption
} from '@icz/angular-form-elements';
import {ReactiveFormsModule} from '@angular/forms';
import {enumToOptions} from '@icz/angular-application-core';

@Component({
  selector: 'icz-general-file-settle-form',
  templateUrl: './general-file-settle-form.component.html',
  styleUrls: ['./general-file-settle-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, IczFormContainerDirective, SectionComponent, FormAutocompleteComponent, DatePickerComponent, IconComponent, FormFieldComponent, AlertComponent, CheckboxComponent, FileTypeSelectorComponent, EntityClassSelectorComponent, ExtRetentionTriggerSelectorComponent]
})
export class GeneralFileSettleFormComponent extends AbstractFileSettleFormComponent implements OnInit {
  @Input()
  minSettlementDate!: Date;
  @Input()
  bulkSettlementDate!: Date;


  protected readonly VisibleClassifiersMode = VisibleClassifiersMode;
  generalTabFileSettlementTypeOptions: IczOption[] = enumToOptions('settlementType', SettlementType);
  isBulkValidSettlementDate = {
    validationFn: (date: Date) => this.isDateValid(date),
    invalidDateMessage : { errorMessageTemplate: 'Datum nesmí být starší než datum založení spisu'}
  };

  override ngOnInit() {
    this.isGeneralFileSettleForm = true;
    super.ngOnInit();
  }

  maxSettlementDate = new Date();

  private isDateValid(date: Date) {
    if (!(date && this.minSettlementDate)) return false;
    return !(date < this.minSettlementDate || date > this.maxSettlementDate);
  }

  get isBulkSettlementByRecord() {
    return this.form.get('fileSettlementType')!.value === SettlementType.BY_RECORD;
  }

  get isBulkSettlementByOtherMethod() {
    return this.form.get('fileSettlementType')!.value === SettlementType.BY_OTHER_METHOD;
  }

  get isBulkSettlementByDocument() {
    return this.form.get('fileSettlementType')!.value === SettlementType.BY_DOCUMENT;
  }

  protected readonly EntityClassSelectorUsage = EntityClassSelectorUsage;
}
